import { Table, Card, Input, Button, Space, Typography } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { MyText } from "Components/MyText/MyText";
const { Title } = Typography;

// data,columns
export const TableListPage = ({
  mainTitle = "",
  data = [],
  columns = [],
  openDrawer,
  filters = () => {},
  showCreateButton = true,
  isLoading = false,
  setSearch,
  search,
  onRowClick = () => {},
  filtersOn = true,
  headerOn = true,
  padding = "",
}) => {
  const handleCreate = async () => {
    openDrawer(true);
  };

  return (
    <div>
      {headerOn && (
        <Card style={{ marginBottom: 16, borderRadius: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Title level={4} style={{ margin: 0 }}>
              {mainTitle}
            </Title>
            {!isLoading && (
              <>
                {showCreateButton && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleCreate}
                  >
                    Створити
                  </Button>
                )}
              </>
            )}
          </div>

          {filtersOn && (
            <div>
              <Space style={{ marginTop: 16 }} wrap>
                <Input
                  placeholder="Пошук за назвою..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ width: 300 }}
                  value={search}
                />
                {filters?.()}
              </Space>

              {/* )} */}
            </div>
          )}
        </Card>
      )}

      {!isLoading ? (
        <>
          {data.length ? (
            <Card
              style={{ borderRadius: 16 }}
              styles={{
                body: {
                  padding: padding,
                },
              }}
            >
              <Table
                rowKey="id"
                columns={columns}
                dataSource={data.filter((i) => {
                  if (search) {
                    return i.title || i.name;
                  } else {
                    return i;
                  }
                })}
                pagination={false}
                onRow={(record) => ({
                  onClick: () => {
                    onRowClick(record);
                  },
                })}
              />
            </Card>
          ) : (
            <MyText text={"Немає даних"} type="primary" />
          )}
        </>
      ) : (
        <MyLoader centered />
      )}
    </div>
  );
};
